import { render } from "./LogradourosTabPage.vue?vue&type=template&id=5e6f83cc"
import script from "./LogradourosTabPage.vue?vue&type=script&lang=js"
export * from "./LogradourosTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__